import 'arrive';

// Import Swiper bundle (include tutti i moduli)
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.arrive('.block-one-product-call-mobile-swiper', { existing: true }, function () {
    const mobileSwiper = new Swiper('.block-one-product-call-mobile-swiper', {
        slidesPerView: 'auto',
        maxwidth: 'fit-content',
        autoHeight: true,
        spaceBetween: 10,
    });
});